import * as React from 'react';

interface CertificationCardIconProps {
  className?: string;
  dataTest?: string;
  width?: number;
  height?: number;
}

const CertificationCardIcon: React.FC<CertificationCardIconProps> = (props) => {
  const { className, dataTest, width = 34, height = 34 } = props;

  return (
    <svg className={className} width={width} height={height} data-test={dataTest} viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M26.9167 18.4167C27.9083 18.4167 28.8575 18.6008 29.75 18.9125V12.75L21.25 4.25H7.08333C5.51083 4.25 4.25 5.51083 4.25 7.08333V26.9167C4.25 28.4892 5.525 29.75 7.08333 29.75H18.9125C18.6008 28.8575 18.4167 27.9083 18.4167 26.9167C18.4167 22.2275 22.2275 18.4167 26.9167 18.4167ZM19.8333 6.375L27.625 14.1667H19.8333V6.375ZM31.875 24.4375L25.1458 31.1667L21.25 26.9167L22.8933 25.2733L25.1458 27.5258L30.2317 22.44L31.875 24.4375Z" fill="#23375E" />
    </svg>
  );
};

export default CertificationCardIcon;
